module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-popover', [_vm._t("default"), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu"
    },
    slot: "popover"
  }, [_vm._t("items")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0998df14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planoList/components/popup-menu.vue
// module id = 3000
// module chunks = 0